import Text from 'components/Text/Text';
import React from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { Link } from 'react-router-dom';
import style from './ChangePositionBtn.module.scss';

const ChangePositionBtn: React.FC = () => {
	return (
		<Link className={style.container} to="/menu/combo-group/positions" data-test="ChangePositionBtn">
			<Button
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#changePosition`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="changePositionButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default ChangePositionBtn;
